export const tsTaskList = [
  { label: "1. Variables", route: "/variable_task", trending: true, tasks: 13 },
  { label: "2. if Conditions", route: "/conditionstattask", tasks: 15 },
  { label: "3. Switch Statement", route: "/switchstatementtask", tasks: 15 },
  { label: "4. Loops Practice", route: "/loopstask", tasks: 15 },
  { label: "5. Function Types", route: "/functiontypestask", tasks: 12 },
  { label: "6. Collections", route: "/collectionstask", tasks: 45 },
  { label: "7. Class & Object", route: "/classobjecttask", tasks: 15 },
  { label: "8. Constructor", route: "/constructortask", tasks: 15 },
  { label: "9. Inheritance", route: "/inheritancetask", tasks: 10 },
  { label: "10. Abstract Class", route: "/abstractclasstask", tasks: 15 },
  { label: "11. Interfaces", route: "/interface_task", trending: true, tasks: 10 },
  { label: "12. Async & Promises", route: "/async_await_task", trending: true, tasks: 10 },
  { label: "13. Python Quiz", route: "/pythontasks", trending: true, tasks: 10 },
  { label: "14. Excel Quiz", route: "/excel-quiz", trending: true, tasks: 40 },
  { label: "15. Playwright Tasks", route: "/playwright_tasks", trending: true, tasks: 14 },
];
